"use client";
import React, { memo } from "react";
import { Carousel } from "react-bootstrap";
import Image from "next/image";

const HeroSection = ({ content }) => {
  const hasMultiple = content?.length > 1;
  return (
    <section
      className="welcome-banner mt-0"
      aria-label="Welcome Banner"
    >
      <Carousel
        controls={false}
        indicators={hasMultiple}
        interval={hasMultiple ? 3000 : null}
        pause={true}
      >
        {content?.map((item, i) => {
          const imageContent = item.section_contents?.find(
            (c) => c.content_type === "image"
          );
          const headingContent = item.section_contents?.find(
            (c) => c.content_type === "heading" || c.content_type === "header"
          );

          if (!imageContent) return null;

          const altText = headingContent?.content || "Dental Care Excellence Banner";

          return (
            <Carousel.Item key={item.id || i} className="hero-image-container">
                <Image
                  src={imageContent.content}
                  alt={altText}
                  title={altText}
                  priority={i === 0}
                  fetchPriority={i === 0 ? "high" : "auto"}
                  className="hero-image"
                  width={1920}
                  height={743}
                  sizes="(max-width: 768px) 70vw, 100vw"
                />
             
            </Carousel.Item>
          );
        })}
      </Carousel>
    </section>
  );
};

export default memo(HeroSection);
